const maxFileSize = 2000000000;

const isFileSizeValid = (fileSize: number) => {
  return fileSize < maxFileSize;
};

export default isFileSizeValid;
